import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

class Loader extends Component {
	message = ''

	
	UNSAFE_componentWillMount() {
		const messages = [
			'One sec...',
			`Won't be long!`,
			`Comin' in hot!`,
			`Un momento...`
		]

		this.message = messages[Math.floor(Math.random() * messages.length)]
	}
	
	render() {
		const {
			noText,
			visible
		} = this.props

		const randomMessage = this.message

		return(
			<CSSTransitionGroup 
				transitionName="fade-in" 
				transitionEnterTimeout={300} 
				transitionLeaveTimeout={300} 
				className="loader"
			>
				{ visible && 
					<x-loader className={ visible && 'active' }>
						<div className="cssload-container">
							<div className="cssload-zenith"></div>
						</div>
						{ !noText && 
							<span>
								{ randomMessage }
							</span>
						}
					</x-loader>
				}
			</CSSTransitionGroup>
		);
	}
}

export default Loader
